import { useForm as createUseForm } from "@ant-design-vue/use";
import { Col, notification, Row } from "ant-design-vue";
import lodash from "lodash";
import moment from "moment";
import { toRaw } from "vue";
import { setIsLoading as setIsLoadingApp } from "../../../../../app.logic";
import { createForm as createFormAddress } from "../../../../../components/address/address.logic";
import { setAppPageHeader } from "../../../../../components/layout/app-layout/app-layout.logic";
import i18n from "../../../../../i18n";
import router from "../../../../../router";
import store from "../../../../../store";
import {
    createButtonActive,
    createButtonArchive,
    createButtonCreate,
    createButtonDelete,
    createButtonEdit,
    createButtonSave,
    createButtonView
} from "../../../../../utils/button";
import {
    checkAttribute,
    initUseForm,
    onClickActive,
    onClickActiveAll,
    onClickArchive,
    onClickArchiveAll,
    onClickCreate,
    onClickDelete,
    onClickDeleteAll,
    onClickEdit,
    onClickView,
    watchRulesChildren
} from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import { has, have } from "../../../../../utils/menu-context";
import {
    createAppPageHeaderTop,
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageExtraCreate,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionView
} from "../../../../../utils/page";
import { flatWhereGroup } from "../../../../../utils/search";
import {
    hasIdCard,
    isAlphabetOrNumber,
    noHyphenValidator,
    required,
    requiredWhen,
    validateError
} from "../../../../../utils/validate";
import websocket from "../../../../../utils/websocket";
import { createRules as createRulesRegister } from "../../../../account/register/register.logic";
import { createForm as createFormUser } from "../../../setting/user-mgt/user/user.logic";
import { callUserRequestDoc, callUserRequestType } from "../tab-4/tab4.section";
import { createConditionAction, createConditionForm } from "./tab1.condition";
import { createColumns, createField, onLinkIdCard } from "./tab1.section";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/userRequest";
export const actionPrefix2 = "resource/v1/security/user";

export const callRequest = ({ form }) => store.dispatch(`${actionPrefix}/request`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } });
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });
export const callSearchUser = ({ criteria }) => store.dispatch(`${actionPrefix2}/search`, { criteria });

export const onSearch = ({ props, page, state, companyId }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where: [...where, ...createWhereFor({ props, companyId })], sort } })
        .then(page => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const onClickSave = ({ props, data, refs, formParams }) => {
    const { viewOnly, routerPrefix } = props;
    return data.useForm
        .validate()
        .then(() => {
            setIsLoadingApp(true);
            return callRequest({ form: { ...data.useForm.modelRef, ...formParams } })
                .finally(() => setIsLoadingApp(false))
                .then(record => {
                    if (viewOnly) initForm({ props, data, refs });
                    else onClickView({ record, routerPrefix });
                });
        })
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createSearchOneCriteria = ({ props, id, companyId, forLog }) => {
    if (!forLog) {
        return {
            select: ["*", "refUser.*", "refUserTemp.**"],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }, ...createWhereFor({ props, companyId })],
            children: [
                {
                    name: "refUserTemp.addresses",
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "refAddressType.seq", type: "ASC" }]
                },
                {
                    name: "refUserTemp.userOperatorTypes",
                    select: ["*", "refOperatorType.*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }]
                },
                {
                    name: "refUserTemp.userObjectives",
                    select: ["*", "refObjective.*"],
                    page: 0,
                    size: 1000000,
                    sort: [{ name: "createDate", type: "ASC" }]
                },
                { name: "refUserTemp.attachments", select: ["*"], page: 0, size: 1000000, sort: [{ name: "createDate", type: "ASC" }] },
                {
                    name: "statuses",
                    asName: "lastStatus.forRequestRemark",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "in", value: ["draft", "reEdit"] }],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.forOfficeRemark",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [
                        {
                            name: "refStatus.key",
                            type: "String",
                            operator: "in",
                            value: ["waitReceiveCustoms", "waitApproveCenter", "waitDocCustoms"]
                        }
                    ],
                    sort: [{ name: "createDate", type: "DESC" }]
                }
            ]
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: []
        };
    }
};

export const createSearchUserOneCriteria = ({ companyId }) => {
    return {
        select: ["**"],
        page: 0,
        size: 1,
        where: [
            { name: "id", type: "UUID", operator: "=", value: companyId },
            { name: "isTemp", type: "Boolean", operator: "=", value: false }
        ],
        children: [
            {
                name: "addresses",
                select: ["**"],
                page: 0,
                size: 1000000,
                sort: [{ name: "refAddressType.seq", type: "ASC" }]
            },
            {
                name: "userOperatorTypes",
                select: ["*", "refOperatorType.*"],
                page: 0,
                size: 1000000,
                sort: [{ name: "createDate", type: "ASC" }]
            },
            {
                name: "userObjectives",
                select: ["*", "refObjective.*"],
                page: 0,
                size: 1000000,
                sort: [{ name: "createDate", type: "ASC" }]
            },
            { name: "attachments", select: ["*"], page: 0, size: 1000000, sort: [{ name: "createDate", type: "ASC" }] }
        ]
    };
};

export const createSearchRequestCheck = ({ companyId }) => {
    return {
        select: ["id"],
        page: 0,
        size: 1,
        where: [
            { openBucket: true, name: "refRequestDoc.key", type: "String", operator: "=", value: "1" },
            {
                closeBucket: true,
                name: "refStatus.key",
                type: "String",
                operator: "in",
                value: ["draft", "reEdit", "waitReceiveCustoms", "waitApproveCenter", "waitDocCustoms"]
            },
            { logic: "OR", openBucket: true, name: "refRequestDoc.key", type: "String", operator: "!=", value: "1" },
            {
                closeBucket: true,
                name: "refStatus.key",
                type: "String",
                operator: "in",
                value: ["reEdit", "waitReceiveCustoms", "waitApproveCenter", "waitDocCustoms"]
            },
            { name: "refOwner.id", type: "UUID", operator: "=", value: companyId }
        ]
    };
};

export const createForm = () => {
    return {
        model: null,
        refModelId: null,
        refModelTempId: null,
        refRequestType: null,
        refRequestDoc: null,
        refStatus: null,
        refDepartment: null,
        statusRemark: null,
        refUser: null,
        refUserTemp: { ...createFormUser(), addresses: [createFormAddress(), createFormAddress()] },
        statuses: [],
        lastStatus: {
            forRequestRemark: [{ remark: null, statusDatetime: null }],
            forOfficeRemark: [{ remark: null, statusDatetime: null }]
        }
    };
};

export const createRules = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return {
        ...createRulesRegister({ data, key: `${prefix}refUserTemp` }),
        [`${prefix}refUserTemp.idCard`]: [
            required, noHyphenValidator(), isAlphabetOrNumber,
            hasIdCard({ cardKey: () => model.refUserTemp.refDocumentTypePerson?.key, idIgnore: () => model.refUser?.id })
        ],
        [`${prefix}refUserTemp.username`]: [],
        [`${prefix}refUserTemp.password`]: [],
        [`${prefix}lastStatus.forRequestRemark.0.remark`]: [requiredWhen({ when: () => !model.isOfficerCreate && model.refRequestType?.key === "2" && (!model.id || ["draft", "reEdit"].includes(model.refStatus?.key)) })]
    };
};

export const createRulesAttachment = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {};
    model?.refUserTemp?.attachments?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refUserTemp.attachments.${index}.documentName`] = [required];
            rules[`${prefix}refUserTemp.attachments.${index}.size`] = [
                requiredWhen({ when: () => model.refUserTemp.attachments[index].attribute?.isRequiredAttachment })
            ];
        }
    });
    return rules;
};

export const createFormTitle = ({ data }) => {
    const modelRef = data.useForm.modelRef;
    if (!modelRef.id) {
        return i18n.global.t("button.create");
    }
    if (modelRef.refUserTemp?.refPersonType?.key === "1") {
        return modelRef.refUserTemp?.companyNameTh;
    }
    return modelRef.refUserTemp?.fullNameTh;
};

export const createWhereFor = ({ props, companyId }) => {
    const { menuContext } = props;
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;
    if (has({ menuContext, key: "forRequest" })) {
        whereGroup.push([{ name: "refOwner.username", type: "String", operator: "=", value: userInfo.username }]);
    }
    if (have({ menuContext, keys: ["forCustoms", "forCenter"] })) {
        whereGroup.push([{ name: "refStatus.key", type: "String", operator: "!=", value: "draft" }]);
    }
    return [
        { name: "refOwner.id", type: "UUID", operator: "=", value: companyId },
        { name: "refRequestDoc.key", type: "String", operator: "=", value: "1" },
        ...flatWhereGroup({ where: whereGroup, logic: "OR" })
    ];
};

export const loadRequestCheck = ({ props, data, refs, state, companyId }) => {
    setIsLoading(true);
    const { id } = data;
    let promise = Promise.resolve({ data: [] });
    if (!id) {
        promise = callSearch({ criteria: createSearchRequestCheck({ props, data, refs, state, companyId }) });
    }
    return promise.finally(() => setIsLoading(false));
};

export const loadForm = ({ props, data, refs, state, companyId }) => {
    setIsLoading(true);
    const { form, routerPrefix } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ props, data, refs, state, companyId, id }) });
    } else {
        promise = Promise.resolve({ data: [useForm.modelRef] });
    }
    return promise
        .then(page => initUseForm({ data, page, routerPrefix }))
        .then(() => loadDefaultForm({ props, data, refs, state, companyId }))
        .then(() => initUseForm({ data, page: { data: [modelRef] }, routerPrefix }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = ({ props, data, refs, state, companyId }) => {
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promiseUser = Promise.resolve(modelRef);
    if (!id) {
        promiseUser = callSearchUser({ criteria: createSearchUserOneCriteria({ props, data, refs, state, companyId }) }).then(d => d.data[0]);
    }
    const promises = [callUserRequestType({}), callUserRequestDoc({}), promiseUser];
    return Promise.all(promises).then(arr => {
        const userInfo = store.state.resource.auth.info?.user;
        data.userRequestTypes = arr[0];
        data.userRequestDocs = arr[1];
        data.user = arr[2];
        if (!id) {
            modelRef.refOwner = userInfo;
            modelRef.refRequestType = data.userRequestTypes.find(d => d.key === "2");
            modelRef.refRequestDoc = data.userRequestDocs.find(d => d.key === "1");
            modelRef.refUser = lodash.cloneDeep(data.user);
            lodash.merge(modelRef.refUserTemp, lodash.cloneDeep(data.user));
        }
    });
};

export const initState = ({ props, companyId }) => {
    const { menuContext, routerPrefix } = props;
    if (stateGroup[companyId]) {
        return stateGroup[companyId];
    }
    const state = {
        columns: createColumns({ personType: router.currentRoute.value.params.personType }),
        page: createPage({
            options: {
                select: [
                    "*",
                    "refRequestType.*",
                    "refStatus.*",
                    "refUserTemp.*",
                    "refUserTemp.refDepartmentRegister.*",
                    "refUserTemp.refDocumentTypePerson.*"
                ],
                sort: [{ name: "updateDate", type: "DESC" }],
                children: [
                    {
                        name: "refUserTemp.userOperatorTypes",
                        select: ["*", "refOperatorType.*"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    }
                ]
            }
        }),
        tableOptions: { search: { activeKey: "Search" } },
        conditionAction: createConditionAction(),
        tabKey: "1",
        websocketId: null,
        websocketSubscribes: []
    };

    state.manages = [
        createManageSelect({ menuContext }),
        createManageActive({
            menuContext,
            confirm: ({ rowSelection }) => ({
                content: rowSelection.selectedRows
                    .map(d => {
                        return d.refPersonType?.key === "1" ? d.refUserTemp.companyNameTh : d.refUserTemp.fullNameTh;
                    })
                    .join(", ")
            }),
            onClick: ({ rowSelection }) =>
                onClickActiveAll({ rowSelection, callActiveAll, state, onSearch: search => onSearch({ props, state, ...search }), setIsLoading })
        }),
        createManageArchive({
            menuContext,
            confirm: ({ rowSelection }) => ({
                content: rowSelection.selectedRows
                    .map(d => {
                        return d.refPersonType?.key === "1" ? d.refUserTemp.companyNameTh : d.refUserTemp.fullNameTh;
                    })
                    .join(", "),
                okType: "danger"
            }),
            onClick: ({ rowSelection }) =>
                onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch: search => onSearch({ props, state, ...search }), setIsLoading })
        }),
        createManageDelete({
            menuContext,
            confirm: ({ rowSelection }) => ({
                content: rowSelection.selectedRows
                    .map(d => {
                        return d.refPersonType?.key === "1" ? d.refUserTemp.companyNameTh : d.refUserTemp.fullNameTh;
                    })
                    .join(", "),
                okType: "danger"
            }),
            onClick: ({ rowSelection }) =>
                onClickDeleteAll({ rowSelection, callDeleteAll, state, onSearch: search => onSearch({ props, state, ...search }), setIsLoading }),
            getCheckboxProps: ({ record }) => ({ disabled: !state.conditionAction.canDelete({ props, record }) })
        }),
        createManageExportCsv({ menuContext })
    ];
    state.manageExtras = [createManageExtraCreate({ menuContext, onClick: () => onClickCreate({ routerPrefix }) })];
    state.rowActions = [
        createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
        createRowActionEdit({
            menuContext,
            onClick: ({ record }) => onClickEdit({ record, routerPrefix }),
            visible: ({ record }) => state.conditionAction.canEdit({ props, record })
        })
    ];
    return (stateGroup[companyId] = state);
};

export const initForm = ({ props, data, refs, state, companyId }) => {
    const { routerPrefix } = props;
    checkAttribute({ props, data, refs, state, companyId });
    data.form = createForm({ props, data, refs, state, companyId });
    data.rules = createRules({ props, data, refs, state, companyId });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, state, companyId, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, state, companyId, isLoading });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refUserTemp.attachments.filter(d => d.isDelete !== true).length,
        createRules: () => createRulesAttachment({ props, data, refs }),
        itemsKey: "refUserTemp.attachments"
    });
    loadRequestCheck({ props, data, refs, state, companyId }).then(page => {
        if (page.data.length > 0) {
            router.push({ name: routerPrefix });
            notification["error"]({ message: i18n.global.t("views.company.mgt.cannotCreateRequest") });
            return Promise.resolve();
        }
        return loadForm({ props, data, refs, state, companyId }).then(() => {
            if (props.setAppPageHeader) {
                setAppPageHeader({
                    slots: {
                        top: () => createAppPageHeaderTop({ props, data, refs, state, routerPrefix, onClickView, onClickEdit }),
                        default: () => createAppPageHeaderDefault({ props, data, refs, state, companyId })
                    }
                });
            }
        });
    });
};

export const createAppPageHeaderDefault = ({ props, data, refs, state }) => {
    const col1 = [];
    const col2 = [];
    const { menuContext, viewOnly, routerPrefix } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const { id, isActive } = modelRef;
    const canEdit = state.conditionAction.canEdit({ props, record: initialModel });
    const canDelete = state.conditionAction.canDelete({ props, record: initialModel });
    if (id && has({ menuContext, key: "canCreate" })) {
        col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && id && has({ menuContext, key: "canView" })) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (viewOnly && id && isActive && canEdit) {
        col1.push(createButtonEdit({ onClick: () => onClickEdit({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && (!id || (id && isActive && canEdit))) {
        col1.push(
            createButtonSave({
                onClick: () => {
                    let statusRemark = null;
                    if ([undefined, "draft", "reEdit"].includes(initialModel.refStatus?.key)) {
                        statusRemark = modelRef.lastStatus.forRequestRemark[0].remark;
                    } else if (["waitReceiveCustoms", "waitApproveCenter", "waitDocCustoms"].includes(initialModel.refStatus?.key)) {
                        statusRemark = modelRef.lastStatus.forOfficeRemark[0].remark;
                    }
                    onClickSave({
                        props,
                        data,
                        refs,
                        formParams: { statusRemark }
                    });
                },
                classStyle: "m-1"
            })
        );
    }
    if (viewOnly && id && !isActive && has({ menuContext, key: "canActive" })) {
        col2.push(
            createButtonActive({
                onClick: () =>
                    onClickActive({
                        record: { id },
                        callActive,
                        setIsLoading: setIsLoadingApp,
                        onClickEdit: () => onClickEdit({ record: { id }, routerPrefix })
                    }),
                classStyle: "m-1"
            })
        );
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: "canArchive" })) {
        col2.push(
            createButtonArchive({
                onClick: () =>
                    onClickArchive({
                        record: { id },
                        callArchive,
                        setIsLoading: setIsLoadingApp,
                        onClickView: () => onClickView({ record: { id }, routerPrefix })
                    }),
                classStyle: "m-1"
            })
        );
    }
    if (!viewOnly && id && isActive && canDelete) {
        col2.push(
            createButtonDelete({
                onClick: () => onClickDelete({ record: { id }, callDelete, setIsLoading: setIsLoadingApp, state, routerPrefix }),
                classStyle: "m-1"
            })
        );
    }
    return (
        <Row type="flex">
            <Col>{col1}</Col>
            <Col class="ml-auto">{col2}</Col>
        </Row>
    );
};

export const onWebsocketConnect = ({ props, data, state }) => {
    state.websocketSubscribes.push(
        websocket.subscribe(`/user/topic/linkage/get/data`, res => {
            mapLinkageGetData({ data, key: "refUserTemp", linkageRes: res });
            if (data.linkageReceive001 && data.linkageReceive009) {
                onLinkIdCard({ props, data, isLoading })(data.linkIdCard);
            }
            setIsLoadingApp(false);
        })
    );
};

export const mapLinkageGetData = ({ data, key, linkageRes }) => {
    const linkageBody = JSON.parse(linkageRes.body);
    const linkageData = linkageBody.data;
    const modelRef = data.useForm.modelRef[key];
    if(modelRef.idCard?.toString() !== linkageData.personalID?.toString()) {
        return;
    }
    if (linkageBody.status === "00000") {
        modelRef.isVerify = true;
        if (linkageData.officeCode === "00023" && linkageData.versionCode === "01" && linkageData.serviceCode === "001") {
            data.linkIdCard.idCard = linkageData.personalID;
            data.linkIdCard.titleCode = linkageData.titleCode;
            data.linkIdCard.titleName = linkageData.titleName;
            data.linkIdCard.genderCode = linkageData.genderCode;
            data.linkIdCard.genderDesc = linkageData.genderDesc;
            data.linkIdCard.birthDate = moment(linkageData.dateOfBirth, ["YYYYMMDD"], true)
                .subtract(543, "years")
                .format("YYYY-MM-DD");
            data.linkIdCard.nationalityCode = linkageData.nationalityCode;
            data.linkIdCard.nationalityDesc = linkageData.nationalityDesc;
            data.linkIdCard.firstNameTh = linkageData.firstName;
            data.linkIdCard.firstNameEn = linkageData.englishFirstName;
            data.linkIdCard.middleNameTh = linkageData.middleName;
            data.linkIdCard.middleNameEn = linkageData.englishMiddleName;
            data.linkIdCard.lastNameTh = linkageData.lastName;
            data.linkIdCard.lastNameEn = linkageData.englishLastName;
            data.linkageReceive001 = true;
        } else if (linkageData.officeCode === "00023" && linkageData.versionCode === "01" && linkageData.serviceCode === "009") {
            const addrThArr = [];
            if (linkageData.address.houseNo?.length > 0) addrThArr.push(linkageData.address.houseNo);
            if (linkageData.address.villageNo > 0)
                addrThArr.push(` ${i18n.global.t("model.address.mooTh").replace(" (TH)", "")} ` + linkageData.address.villageNo);
            if (linkageData.address.alleyDesc?.length > 0)
                addrThArr.push(` ${i18n.global.t("model.address.soiTh").replace(" (TH)", "")}` + linkageData.address.alleyDesc);
            if (linkageData.address.roadDesc?.length > 0)
                addrThArr.push(` ${i18n.global.t("model.address.roadTh").replace(" (TH)", "")}` + linkageData.address.roadDesc);
            if (linkageData.address.subdistrictDesc?.length > 0)
                addrThArr.push(` ${i18n.global.t("model.address.refTambon").replace(" (TH)", "")} ` + linkageData.address.subdistrictDesc);
            if (linkageData.address.districtDesc?.length > 0)
                addrThArr.push(` ${i18n.global.t("model.address.refAmphur").replace(" (TH)", "")} ` + linkageData.address.districtDesc);
            if (linkageData.address.provinceDesc?.length > 0)
                addrThArr.push(` ${i18n.global.t("model.address.refProvince").replace(" (TH)", "")} ` + linkageData.address.provinceDesc);
            data.linkIdCard.addresses = [{ addrTh: addrThArr.join(" ") }];
            data.linkageReceive009 = true;
        }
    } else if (linkageBody?.length > 0) {
        notification["error"]({ message: linkageBody.message });
    }
};

export const stateGroup = [];
